"use client";

import { Icon } from "@templates/design-system";
import { useState } from "react";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import type { IVideoPlayerProps } from "./VideoPlayer.props";

export const VideoPlayer = ({
  banner,
  directVideo,
  source,
  vimeoVideo,
  youtubeVideo,
}: IVideoPlayerProps) => {
  const video =
    source === "direct" ? directVideo : source === "youtube" ? youtubeVideo : vimeoVideo;
  const [playing, setPlaying] = useState(false);
  if (!video) return null;
  const autoplay = `${video}${video.includes("?") ? "&" : "?"}autoplay=1`;
  const player =
    source === "direct" ? (
      <video
        autoPlay={playing}
        className="absolute inset-0 h-full w-full bg-terminal object-cover"
        controls
        playsInline
        src={video}
      />
    ) : (
      <iframe
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute inset-0 h-full w-full"
        loading="lazy"
        src={playing ? autoplay : video}
        title={`${source} video`}
      />
    );

  return (
    <div className="relative aspect-video overflow-hidden bg-terminal">
      {banner && !playing ? (
        <button
          aria-label="Play video"
          className="group absolute inset-0 block h-full w-full cursor-pointer overflow-hidden text-left focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring"
          onClick={() => setPlaying(true)}
          type="button"
        >
          <DaylightMedia
            aspectRatio="16:9"
            className="pointer-events-none h-full border-0"
            imageClassName="object-cover transition-transform duration-300 ease-out group-hover:scale-[1.015] motion-reduce:transition-none motion-reduce:group-hover:scale-100"
            media={banner.image}
            sizes="(min-width: 1600px) 1520px, 100vw"
          />
          <span aria-hidden="true" className="absolute inset-0 bg-terminal/45" />
          <span className="absolute bottom-0 left-0 flex items-center gap-4 bg-terminal px-5 py-4 text-graphite">
            <Icon className="size-5 text-primary" name="play" />
            <span className="daylight-label">Video abspielen</span>
          </span>
        </button>
      ) : (
        player
      )}
    </div>
  );
};

VideoPlayer.displayName = "Content::VideoPlayer";
